import React from "react";
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { BASE, shouldShowBepassLogo } from '../basedata/constants';

import "./NotFound.sass";

import linkInvalid from "../images/ilustra-link-invalido.png";
import { LanguageSelector } from "../components/LanguageSelector/LanguageSelector"

const NotFound = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const showFooterLogo = shouldShowBepassLogo();
  const footerLogo = isMobile ? BASE.company.bepassMobileLogo : BASE.company.bepassLogo;

  return (
    <Box className="not-found-wrapper">
      
      <header className="not-found-header">
        <LanguageSelector />
      </header>

        <Box className="not-found-inner">
          <img className="not-found-logo" src={BASE.company.logo} alt={BASE.company.name} />
          <Box className="not-found-text">
            <Box className="not-found-header-info">
              <h1 className="not-found-title">{t('notFound.title')}</h1>
              <p className="not-found-generic-text">{t('notFound.subTitle')}</p>
            </Box>
            <Box className="not-found-container-generic-link">
              <img className="not-found-image-link" src={linkInvalid} alt="Link inválido" />
            </Box>
            <p className="not-found-generic-text">{t('notFound.tryAgain')}</p>
          </Box>
      </Box>

      {showFooterLogo && (
        <footer className="not-found-footer">
          <img
            src={footerLogo}
            alt="Bepass Logo"
            className="footer-logo"
          />
        </footer>
      )}
    </Box>
  );
};

export default NotFound;
